import { useCallback, useState } from 'react'
import { ClientKnownAddressModal } from './ClientKnownAddressModal'

import { icons, Flex, Spacer, ColourButton } from 'portal/lib/primitives'
import { Tooltip } from 'antd'

import { colours } from '@qflow/theme'
import ClientRemoveKnownAddressWarningModal from './ClientRemoveKnownAddressWarningModal'

export type ClientAddressName =
  | 'Site'
  | 'Delivery'
  | 'Dispatch'
  | 'Origin Site'
  | 'Facility Site'

export type KnownAddressResult = {
  entered: string
  known: string
  coordinates: { lat: number; lon: number }
}

export type ClearKnownAddressInput = {
  entered: null
  known: null
  coordinates: null
}

export function ClientKnownAddressModalLink({
  addressName,
  hasValue,
  onSubmit,
  onRemove
}: {
  addressName: ClientAddressName
  hasValue: boolean
  onSubmit: (result: KnownAddressResult | ClearKnownAddressInput) => void
  onRemove: () => void
}) {
  const [knownAddressModalOpen, setKnownAddressModalOpen] =
    useState<boolean>(false)
  const [removeKnownAddressModalOpen, setRemoveKnownAddressModalOpen] =
    useState<boolean>(false)

  const handleSubmit = useCallback(
    (result: KnownAddressResult) => {
      onSubmit(result)
      setKnownAddressModalOpen(false)
    },
    [onSubmit]
  )
  const handleRemove = useCallback(() => {
    onRemove()
    setRemoveKnownAddressModalOpen(false)
  }, [onRemove])

  return (
    <>
      {hasValue && (
        <div>
          <Flex.Row>
            <Tooltip title={'Edit Address'}>
              <ColourButton.Basic
                style={{
                  maxHeight: '2.5rem',
                  borderColor: colours.BORDER_GREY
                }}
                type="button"
                aria-label={`Edit Known ${addressName} Address`}
                onClick={() => setKnownAddressModalOpen(true)}
                tabIndex={-1}
              >
                <icons.Edit colour="currentColor" />
              </ColourButton.Basic>
            </Tooltip>

            <Spacer.Fine />
            <Tooltip title={'Remove Address'}>
              <ColourButton.NegativeSecondary
                style={{
                  maxHeight: '2.5rem',
                  borderColor: colours.BORDER_GREY
                }}
                type="button"
                aria-label={`Delete Known ${addressName} Address`}
                onClick={() => setRemoveKnownAddressModalOpen(true)}
                tabIndex={-1}
              >
                <icons.TrashCan colour="currentColor" />
              </ColourButton.NegativeSecondary>
            </Tooltip>
          </Flex.Row>
        </div>
      )}
      {!hasValue && (
        <ColourButton.Action
          style={{ maxHeight: '2.5rem' }}
          type="button"
          aria-label={`Add Known ${addressName} Address`}
          onClick={() => setKnownAddressModalOpen(true)}
          tabIndex={-1}
        >
          Add address
        </ColourButton.Action>
      )}

      {knownAddressModalOpen && (
        <ClientKnownAddressModal
          addressName={addressName}
          isOpen={true}
          onCancel={() => setKnownAddressModalOpen(false)}
          onSubmit={handleSubmit}
        />
      )}
      {removeKnownAddressModalOpen && (
        <ClientRemoveKnownAddressWarningModal
          addressName={addressName}
          isOpen={true}
          onCancel={() => setRemoveKnownAddressModalOpen(false)}
          onSubmit={handleRemove}
        />
      )}
    </>
  )
}
